import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
//import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "@fontsource/barlow";
import "@fontsource/barlow-condensed";
import {BrowserRouter} from "react-router-dom";

const theme = createTheme({
    palette: {
        mode: 'dark',
        white: {
            main: '#FFFFFF',
            light: '#FFFFFF',
            dark: '#FFFFFF',
            contrastText: '#FFFFFF',
        },
        sfuRed: {
            main: '#CC0633',
            light: '#CC0633',
            dark: '#A6192E',
            contrastText: '#FFFFFF',
        },
    },
    typography: {
        fontFamily: `"Barlow", "Roboto", "Helvetica", "Arial", sans-serif`
    }
});

const root = createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
      <ThemeProvider theme={theme}>
          <CssBaseline />
          <BrowserRouter>
            <App />
          </BrowserRouter>
      </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
